/* eslint-disable no-undef */
import {post} from './api';
import {showLoading, hideLoading} from './loading';
import router from '@router/index.js';
import store from '@/store';
import {bus} from '@js/util/index.js';
import {apiUrl} from '@js/config/index.js';
import {EndPoint} from '@threegene/common-js/common';
import {getUserInfo} from '@threegene/xdm-js-bridge';
import {CommonApiAuth} from '@threegene/common-js/auth';
import {getUserTokenByActToken} from '@threegene/common-js/xdm/auth/token.ctrl';

const commonApiAuth = new CommonApiAuth('xdm');

let firstErrorTime = 0;
let lastErrorTime = 0;
let tokenErrorCount = 0;

let refreshTokenP;

function isAlwaysError() {
  let alwaysError = false;
  if (tokenErrorCount === 1) {
    firstErrorTime = new Date().getTime();
  }

  const now = new Date().getTime();
  lastErrorTime = now;
  // 在1s内连续报错5次
  if (tokenErrorCount > 5) {
    if (0 < Number((now - firstErrorTime) / tokenErrorCount) < 50 && 0 < now - lastErrorTime < 50) {
      alwaysError = true;
    }
  }
  return alwaysError;
}

/**
 * @desc 刷新token
 */
async function refreshToken() {
  try {
    if (!refreshTokenP) {
      refreshTokenP = EndPoint.isXDM
        ? getUserInfo()
        : commonAPI('UPDATE_TOKEN', null, {
            blLoading: false,
            needRefreshToken: false
          });
    }
    const {token} = await refreshTokenP;
    // 更新用户信息
    store.commit('global/SET_TOKEN', token);
    // 更新用户信息
    store.dispatch('global/getUserInfo');
    return true;
  } catch (e) {
    return false;
  }
}

const commonAPI = (url, params, config) => {
  // 公共处理的请求，返回请求结果
  return new Promise(async (resolve, reject) => {
    if (!url) return;
    params = params || {};
    config = typeof config === 'object' ? config : {};
    // 请求接口是否加载loading  loading可配置
    config.blLoading = Object.prototype.hasOwnProperty.call(config, 'blLoading') ? config.blLoading : true;
    // 接口是否返回错误
    config.blNeedHandleError = Object.prototype.hasOwnProperty.call(config, 'blNeedHandleError') ? config.blNeedHandleError : false;
    // 接口是否需要刷新token
    config.needRefreshToken = Object.prototype.hasOwnProperty.call(config, 'needRefreshToken') ? config.needRefreshToken : true;

    // 接口是否需要加token
    if (Object.prototype.hasOwnProperty.call(config, 'needToken')) {
      const userToken = await getUserTokenByActToken(store.getters['global/token']);
      store.commit('global/SET_TOKEN', userToken);
      params.token = userToken;
    }
    if (config.blLoading) {
      // 展示loading
      showLoading();
    }
    delete params.sign;
    params.nonce = commonApiAuth.randomWord(false, 32, 32);
    // 加密
    const copyParams = JSON.parse(JSON.stringify(params));
    const encryptParam = commonApiAuth.md5Encryption(copyParams);

    post(url, encryptParam)
      .then(async res => {
        const CODE = res.code;
        // 成功的请求
        if (CODE === '00000') {
          resolve(res.data);
        } else {
          if (CODE === '00600010006' || CODE === '00200010006') {
            // token异常
            tokenErrorCount++;
            // 登录状态改变
            bus.$once('update-token', async function () {
              const res = await commonAPI(url, params, config);
              resolve(res);
            });
            // 后台一直报错
            if (isAlwaysError()) {
              // 跳转到错误页面
              router.push({name: 'error', params: {code: '-10'}});
            } else {
              // 并发token报错，只请求一次
              if (tokenErrorCount === 1 && config.needRefreshToken) {
                // 更新token
                const succcess = await refreshToken();
                if (succcess) {
                  bus.$emit('update-token');
                } else {
                  // 跳转到错误页面
                  router.push({name: 'error', params: {code: '-11'}});
                }
                setTimeout(function () {
                  tokenErrorCount = 0;
                }, 1000);
              }
            }
          } else if (CODE === '50307230000') {
            // 分享过期
            router.push({name: 'overtime'});
          } else {
            // 非token异常，判断是否要返回错误信息
            if (config.blNeedHandleError) {
              reject(res);
            } else {
              router.push({name: 'error', params: {text: res.errorMsg}});
            }
          }
        }
      })
      .catch(err => {
        hideLoading();
        // 请求失败  错误状态码
        const errorCode = err.response.status;
        router.push({name: 'error', params: {code: errorCode}});
      });
  });
};

const handleAPI = (api, params, config) => {
  return new Promise(async (resolve, reject) => {
    let data;
    try {
      // 判断该接口模块是否有该接口
      if (apiUrl[api]) {
        // 请求数据
        data = await commonAPI(apiUrl[api], params, config);
      }
      resolve(data);
    } catch (err) {
      reject(err);
    }
  });
};

export {handleAPI};



// WEBPACK FOOTER //
// ./src/js/fetch/common.js